// Import package.json version and build number
import { version, buildNumber } from '../../package.json';
import { Platform, OnboardingMethod, SkipNameInfo, SwitcherType } from './types';
import { getPlatform } from './utils/platform';

export const APP_VERSION = version;
export const BUILD_NUMBER = buildNumber;
export const LOG_TO_SUPABASE = false;
export const FORCE_DANISH = false;
export const ONBOARDING_METHOD: OnboardingMethod = OnboardingMethod.Wizard;
export const SKIP_NAME_INFO: SkipNameInfo = SkipNameInfo.Skip;
export const DISABLE_POSTHOG = false;
export const SWITCHER_TYPE: SwitcherType = SwitcherType.PillToggle;
export const LOAD_CALENDAR_EXAMPLE = false;
export const SKIP_MAX_STEPS = true;

export const ANNIE_ELK_USER_ID = '2e376ed9-af06-4f0b-a61c-4268e9e7f92d';

export const CHAT_VERSION = 'V1';

// TODOAPPLE: get proper id
export const APP_STORE_URL = 'https://apps.apple.com/app/your-app-id'
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.usenestor.app'

// Version parts for easy access
export const VERSION_PARTS = {
  major: parseInt(APP_VERSION.split('.')[0]),
  minor: parseInt(APP_VERSION.split('.')[1]),
  patch: parseInt(APP_VERSION.split('.')[2]),
};

// Export Platform enum for convenience
export { Platform };

// Export getPlatform for backwards compatibility
export { getPlatform };

// Add standardized release string generation
export function getReleaseString(
  environment: string = 'development',
  // Allow override of platform for build-time usage
  platformOverride?: Platform
): string {
  const platform = platformOverride || getPlatform();
  return `nestor@${APP_VERSION}+${BUILD_NUMBER}@${platform}@${environment}`;
}

// Get build number for native platforms
export function getBuildNumber(): number {
  return BUILD_NUMBER;
}

// roles
export const HELPER_ROLE_MAINHELPER = 'mainhelper';
export const HELPER_ROLE_ASSISTINGHELPER = 'assistinghelper';

// testing
export const TEST_CUSTOMER_EMAIL = 'mortenelk+tstnst@gmail.com';
export const TEST_CUSTOMER_PASSWORD = '123456';
export const TEST_CUSTOMER_EMAIL_2 = 'mortenelk+tstnst_2@gmail.com';


// web client signals
export const AUTH_HOME_CLICK = 'auth_home_click';

// MicroWizard constants
export const MICROWIZARD_PREFERENCE_PREFIX = 'microwizard_';
export const MICROWIZARD_COMPLETED_SUFFIX = '_completed';
export const MICROWIZARD_DISMISSED_SUFFIX = '_dismissed';

export const MICROWIZARD_TYPES = {
  TEXT: 'text',
  IMAGE: 'image',
  VIDEO: 'video',
  CUSTOM: 'custom'
};

export const MICROWIZARD_ACTIONS = {
  NEXT: 'NEXT',
  PREVIOUS: 'PREVIOUS',
  COMPLETE: 'COMPLETE',
  DISMISS: 'DISMISS'
};
